const services = [
  {
    title: "Cross-functional projects.",
    body:
      "The kind of thinking that usually only happens in the founder's head, applied across your whole org. I sit between teams, keep the plan honest, and stay close enough to help put it into motion.",
    testid: "service-cross-functional",
  },
  {
    title: "AI rollouts that actually ship.",
    body:
      "We figure out where AI earns its place in your workflow, and where it's just adding noise. The goal isn't to ship AI. It's to ship the right thing.",
    testid: "service-ai-implementation",
  },
  {
    title: "Operational rebuilds.",
    body:
      "The system that worked at half the size and now creaks under the load. I take on the rebuild, ship the change with your team, and leave the ops running cleaner than I found them.",
    testid: "service-operational-rebuilds",
  },
  {
    title: "High-stakes launches.",
    body:
      "When the launch is big and the answer isn't obvious, I help lower the temperature in the room, name the actual tradeoffs, and walk in clear about what the team is shipping and why.",
    testid: "service-high-stakes-launches",
  },
];

export default function WhatIDo() {
  return (
    <section
      id="what"
      data-testid="section-what"
      className="bg-sand"
    >
      <div className="mx-auto max-w-[1100px] px-6 py-20 md:px-10 md:py-28 lg:py-32">
        <h2 className="section-heading max-w-[680px]">
          What I actually do.
        </h2>

        <article
          data-testid="service-stalled-initiatives"
          className="brand-card mt-12 md:mt-16"
          style={{
            borderLeft: "3px solid var(--color-deep-lake)",
          }}
        >
          <h3
            className="text-deep-lake"
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontWeight: 500,
              fontSize: "20px",
              lineHeight: 1.35,
            }}
          >
            Stalled initiatives, moved to done.
          </h3>
          <p
            className="mt-3 max-w-[720px]"
            style={{
              fontFamily: "Inter, Arial, sans-serif",
              fontSize: "16px",
              lineHeight: 1.65,
              color: "rgba(26,58,79,0.78)",
            }}
          >
            The launch that keeps sliding. The rollout that never quite lands. I take on the piece that has been stuck, get it across the line, and hand back a team that knows how to finish the next one on their own.
          </p>
        </article>

        <div className="mt-6 grid grid-cols-1 gap-6 md:mt-8 md:grid-cols-2 md:gap-8">
          {services.map(({ title, body, testid }) => (
            <article
              key={testid}
              data-testid={testid}
              className="brand-card"
            >
              <h3
                className="text-deep-lake"
                style={{
                  fontFamily: "Inter, Arial, sans-serif",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: 1.4,
                }}
              >
                {title}
              </h3>
              <p
                className="mt-3"
                style={{
                  fontFamily: "Inter, Arial, sans-serif",
                  fontSize: "16px",
                  lineHeight: 1.65,
                  color: "rgba(26,58,79,0.78)",
                }}
              >
                {body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
